import { IGameBlackjackDraw } from '@bg-shared/interfaces/Draws/IBlackjackDraw';
import { IPLSGameId } from '@bg-shared/interfaces/GameId';
import { IGameBlackjackModel } from './interfaces';

export const gameBlackjackSelectors = {
    selectData:
        (gameId: IPLSGameId) =>
        (state: IGameBlackjackModel): IGameBlackjackDraw =>
            state.data[gameId],

    getAvailableSeats:
        (gameId: IPLSGameId) =>
        (state: IGameBlackjackModel): number => {
            if (!state.data?.[gameId]) {
                return 0;
            }
            const { seatCount, takenSeats } = state.data[gameId].details;
            return seatCount - takenSeats.length;
        },
};
